import Kpis from './Kpis'
import List from './children/List'
import New from './children/New'
import Edit from './children/Edit'
import Kpi from './children/Kpi'

export default Kpis
export { List, New, Edit, Kpi }
